<template>
    <div id="printReport">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
                </div>
                <div class="col-sm-8">
                    <h3 class="text-center">Relatório de Pós Venda</h3>
                </div>
                <div class="col-sm-2"></div>
            </div>
            <div class="row mt-3" id="conteudo">
                <div class="col-sm-12">
                    <div class="panel panel-defaul">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Data {{ form.date_by === 'contracts.formalized_at' ? 'da Venda' : 'do Envio documentação' }}</label>
                                    <br />
                                    <div >{{ form.created_at.length ? moment(form.created_at[0]).format('DD/MM/YYYY') : 'Todas' }} à {{ form.created_at.length ? moment(form.created_at[1]).format('DD/MM/YYYY') : 'Todas' }}</div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <label>Loja</label>
                                    <br />
                                    <div>{{ branches.find(branche => branche.id === form.branch_id).name }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Equipe</label>
                                    <br />
                                    <div>{{ form.team_id && teams.length > 0 ? teams.find(team => team.id === form.team_id).name : 'Todas' }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Representante</label>
                                    <br />
                                    <div>{{ form.representative_id ? representatives.find(representative => representative.id === form.representative_id).name : 'Todos' }}</div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <label>Status</label>
                                    <br />
                                    <div>{{ form.status_id && contract_status.length > 0 && contract_status.find(contract_state => contract_state.id === form.status_id) ? contract_status.find(contract_state => contract_state.id === form.status_id).status : 'Todos' }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Situação</label>
                                    <br />
                                    <div>{{ form.situation ? situations.find(situation => situation.id === form.situation).name : 'Todas' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-12 text-center">
                    <div style="max-height: 400px; max-width: 600px; margin: 0 auto;">
                        <apexchart type="pie" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="panel panel-defaul">
                        <div class="panel-body" style="overflow-x: auto;">
                            <table id="tabela" class="table b-table table-sm" v-if="form.status_id && contract_status.length > 0 && contract_status.find(contract_state => contract_state.id === form.status_id) && contract_status.find(contract_state => contract_state.id === form.status_id).is_pending">
                                <thead>
                                    <tr>
                                        <th>Contrato</th>
                                        <th>Grupo</th>
                                        <th>Cota</th>
                                        <th>Cliente</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Pendência</th>
                                        <th>Situação</th>
                                        <th>Representante</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="contract in report_data">
                                        <td>{{ contract.physical_proposal }}</td>
                                        <td>{{ contract.group }}</td>
                                        <td>{{ contract.quota }}</td>
                                        <td>{{ contract.client_name }}</td>
                                        <td>{{ contract.cpf_cnpj }}</td>
                                        <td>{{ contract.pending_reasons.map(pending_reason => pending_reason.description).join(', ') }}</td>
                                        <td>{{ contract.situation == 'A' ? 'Alocada' : (afterSale.situation == 'C' ? 'Cancelada' : 'Não alocada') }}</td>
                                        <td>{{ contract.representative_name }}</td>
                                        <td>
                                            <router-link
                                                data-original-title
                                                title="Histórico da formalização"
                                                class="btn btn-outline-primary btn-link"
                                                tag="button"
                                                :to="{
                                                    name: 'reports.print-contracts.history', 
                                                    params: {
                                                        id: contract.id
                                                    }, 
                                                    query: $route.query
                                                }"
                                                >
                                                <i class="material-icons">find_in_page</i>
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table id="tabela" class="table b-table table-sm" v-else>
                                <thead>
                                    <tr>
                                        <th>Contrato</th>
                                        <th>Grupo</th>
                                        <th>Cota</th>
                                        <th>Cliente</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Status</th>
                                        <th>Situação</th>
                                        <th>Representante</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="contract in report_data">
                                        <td>{{ contract.physical_proposal }}</td>
                                        <td>{{ contract.group }}</td>
                                        <td>{{ contract.quota }}</td>
                                        <td>{{ contract.client_name }}</td>
                                        <td>{{ contract.cpf_cnpj }}</td>
                                        <td>{{ contract.status }}</td>
                                        <td>{{ contract.situation == 'A' ? 'Alocada' : (afterSale.situation == 'C' ? 'Cancelada' : 'Não alocada') }}</td>
                                        <td>{{ contract.representative_name }}</td>
                                        <td>
                                            <router-link
                                                data-original-title
                                                title="Histórico da formalização"
                                                class="btn btn-outline-primary btn-link"
                                                tag="button"
                                                :to="{
                                                    name: 'reports.print-contracts.history', 
                                                    params: {
                                                        id: contract.id
                                                    }, 
                                                    query: $route.query
                                                }"
                                                >
                                                <i class="material-icons">find_in_page</i>
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container dont-print mt-3">
            <div class="row">
                <div class="col-md-12 text-center">
                    <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
                    <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
                </div>
            </div>
        </div>
        <b-modal
            ref="modal"
            dialog-class="modal-lg"
            hide-footer
            scrollable
            :visible="$route.meta.showModal"
            :title="$route.meta.title"
            @hide="hideModal"
            >
            <router-view name="modal" />
        </b-modal>
    </div>
</template>

<script>
    import Vue from "vue";
    import VueApexCharts from "vue-apexcharts";

    export default {
        components: {
            apexchart: VueApexCharts,
        },
        computed: {
            contract_status() {
                var contract_status = [
                    {
                        id: null,
                        status: "Todos"
                    }
                ];
                return contract_status.concat(this.$store.state.contract_status.itens);
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            chartOptions() {
                return {
                    chart: {
                        type: 'pie',
                        height: "250px",
                        width: "600px",
                        events: {
                            dataPointSelection: (event, chartContext, opts) => {
                                var itemSelected = null;
                                if (this.form.status_id && this.contract_status.length > 0 && this.contract_status.find(contract_state => contract_state.id === this.form.status_id) && this.contract_status.find(contract_state => contract_state.id === this.form.status_id).is_pending) {
                                    itemSelected = this.$store.state.pending_reasons.itens[opts.dataPointIndex].description;
                                } else {
                                    itemSelected = this.$store.state.contract_status.itens[opts.dataPointIndex].status;
                                }

                                this.setFilterBy(itemSelected);
                            }
                        }
                    },
                    stroke: {
                        colors: ['#000']
                    },
                    fill: {
                        opacity: 0.8
                    },
                    labels: (this.form.status_id && this.contract_status.length > 0 && this.contract_status.find(contract_state => contract_state.id === this.form.status_id) && this.contract_status.find(contract_state => contract_state.id === this.form.status_id).is_pending) ? this.$store.state.pending_reasons.itens.map(status => status.description) : this.$store.state.contract_status.itens.map(status => status.status),
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 600
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        }
                    ]
                };
            },
            pending_reasons() {
                return this.$store.state.pending_reasons.itens;
            },
            report_data() {
                if (this.filterKey) {
                    if (!this.form.status_id || this.form.status_id === null) {
                        return this.$store.state.reports.item.filter(contract => contract.status == this.filterKey);
                    }
                    
                    return this.$store.state.reports.item.filter(contract => {
                        return contract.pending_reasons.find(pending_reason => pending_reason.description === this.filterKey) !== undefined;
                    });
                }

                return this.$store.state.reports.item;
            },
            representatives() {
                var salesmans = [
                    {
                        id: null,
                        name: "Todos"
                    }
                ];
                return salesmans.concat(this.$store.state.users.salesmans);
            },
            series() {
                var series = [];
                
                if (this.form.status_id && this.contract_status.length > 0 && this.contract_status.find(contract_state => contract_state.id === this.form.status_id) && this.contract_status.find(contract_state => contract_state.id === this.form.status_id).is_pending) {
                    this.$store.state.pending_reasons.itens.forEach(pendingReason => {
                        series.push(this.$store.state.reports.item.filter(contract => {
                            return contract.pending_reasons.find(pending_reason => pending_reason.description === pendingReason.description) !== undefined;
                        }).length);
                    });
                } else {
                    this.$store.state.contract_status.itens.forEach(contractStatus => {
                        if (this.$store.state.reports.item.length > 0) {
                            series.push(this.$store.state.reports.item.filter(contract => contract.status === contractStatus.status).length);
                        } else {
                            series.push(0);
                        }
                    });
                }

                return series;
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        created() {
            var self = this;
            
            self.getDataContractStatus();

            self.form = JSON.parse(self.$route.query.form);

            this.$root.$on("hideModal", () => {
                this.$refs.modal.hide();
            });
        },
        data() {
            return {
                filterKey: null,
                moment: Vue.moment,
                store_branch: null,
                situations: [
                    {
                        id: "A",
                        name: "Alocada"
                    },
                    {
                        id: "C",
                        name: "Cancelada"
                    },
                    {
                        id: "N",
                        name: "Não alocada"
                    },
                    {
                        id: "T",
                        name: "Todas"
                    }
                ],
            };
        },
        methods: {
            close() {
                window.opener.focus();
                window.close();
            },
            differenceDates(firstDate, secondDate) {
                const differenceInHours = Vue.moment(firstDate).diff(Vue.moment(secondDate), 'hours');

                if (differenceInHours < 24) {
                    return differenceInHours + ' horas';
                }

                return Vue.moment(firstDate).diff(Vue.moment(secondDate), 'days') + ' dias';
            },
            async getDataContractStatus() {
              var self = this;

              self.$root.$emit('onLoading');
              const response = self.$store.dispatch('contract_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });
            },
            async getPendingReasons() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('pending_reasons/all');

                response.then(function () {
                    self.$root.$emit('onLoading');

                    self.getReportData();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');

                    self.getReportData();
                });
            },
            async getReportData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch(
                    'reports/contracts',
                    self.form
                );

                response.then(function () {
                    self.$root.$emit('onLoading');
                });
                
            },
            async getSalesmans() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('users/getSalesmans', {all_users:true});

                response.then(() => {
                    self.$root.$emit('onLoading');

                    self.getTeams();
                });

                response.catch(() => {
                    self.$root.$emit('onLoading');

                    self.getTeams();
                });
            },
            async getTeams() {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/all');


                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getPendingReasons();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getPendingReasons();
                });
            },
            hideModal() {
                this.$router.go(-1);
            },
            print() {
                window.print();
            },
            setFilterBy(filterKey) {
                if (this.filterKey === filterKey) {
                    this.filterKey = null;
                } else {
                    this.filterKey = filterKey;
                }
            }
        }
    };
</script>
